import { Directive, EventEmitter, Input, Output } from '@angular/core';

import { HistoryBookingDetail } from '@user-history/entities/history-booking-detail';
import { User } from '@app/modules/core/interfaces/user';
import { ReservationType } from '@user-history/entities/user-history-item';

@Directive()
export abstract class AbandonedReservationsAbstract {

  @Input() itinerary: HistoryBookingDetail;
  @Input() reservationType: ReservationType;
  @Input() user: User;
  @Input() isMobile: boolean;
  @Input() isLoadingCancellation: boolean;

  @Output() cancelEvent: EventEmitter<number> = new EventEmitter<number>();
}
